__turbopack_context__.v({
  "className": "lato_f8b0dea-module__bACb0a__className",
  "variable": "lato_f8b0dea-module__bACb0a__variable",
});
